import React from 'react';
import "./BlockUnblockAgent.css";
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import lock from "../../assets/images/lock.png"
import unlock from "../../assets/images/unlock.png"
import { reload } from '../../utils/utils';

const BlockUnblockAgent = (props) => {

    const { show, handleNoClicked, title, id, handleYesClicked } = props;
    const dispatch = useDispatch();
        const states = useSelector((state) => state, shallowEqual);

  return (
    <Modal show={show} onHide={handleNoClicked} animation={true} className="rotateInDownLeft"  tabindex="-1" role="dialog" backdrop="static" aria-hidden="true">
            <div className="modal-content">
                <div class="modal-header text-center py-1">
                    <h4 className="">{states.blockOrUnblockModal === "block" ? "Blocage" : "Déblocage"}</h4>
                    <button type="button" onClick={() => handleNoClicked(id)} class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                <img src={states.blockOrUnblockModal === "block" ? lock : unlock} style={{width: "50%", height: "50%", marginLeft: "auto", marginRight: "auto", marginBottom: 15}} />
                    <p className="mb-3" id="exampleModalLabel">
                        { states.blockOrUnblockModal === "block" ? "Etes-vous sûr de vouloir bloquer" : "Etes-vous sûr de vouloir débloquer"}
                         <span style={{color: "#FFC23A", fontWeight: "bold"}}>{title}</span> </p>
                </div>
                <div className="modal-footer py-1">
                    <button style={{fontWeight: "bold"}} className="btn" data-dismiss="modal" onClick={() => handleNoClicked(id)}><i className="flaticon-cancel-12"></i> NON</button>
                    <button style={{color:  "#FFC23A", fontWeight: "bold"}} type="button" className="btn ml-3" onClick={() => handleYesClicked(id)}>OUI</button>
                </div>
            </div>
        </Modal>
  )
}

export default BlockUnblockAgent
